import { CalendarRoot } from "PFApp/booking/types/calendar_root";
import { FiltersMetaV2, FiltersV2, FilterV2WithValueOnly } from "PFTypes/filters_v2";

export enum CalendarMode {
  Workforce = "workforce",
  Projects = "projects"
}

export type CalendarModeInitialData = {
  filters?: FiltersV2<FilterV2WithValueOnly>;
  calendarRoot?: CalendarRoot;
  filtersMetaCallback?: (filtersMeta: FiltersMetaV2) => void;
};
